import React, { useState } from 'react';
import Teams from './Component/Team.json'
import { Divider, Typography } from '@mui/material';
import PageHeader from './Component/PageHeader';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ChevronDown } from 'lucide-react';


const TransparentAccordion = styled(Accordion)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1f2937' : 'transparent',
    color: theme.palette.mode === 'dark' ? '#ffffff' : 'inherit',
}));

const TransparentAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1f2937' : 'transparent',
    color: theme.palette.mode === 'dark' ? '#ffffff' : 'inherit',
}));

const TransparentAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1f2937' : 'transparent',
    color: theme.palette.mode === 'dark' ? '#ffffff' : 'inherit',
}));

const CustomExpandMoreIcon = styled(ChevronDown)(({ theme }) => ({
    color: theme.palette.mode === 'dark' ? '#F13030' : '#F13030',
}));

const ManagementTeam = () => {

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div>

            <div className='mx-16 py-8'>
                <div><PageHeader pageTitle="Management Team" /></div>
                {Teams.map((team, index) => (
                    <TransparentAccordion className='my-5'
                        key={index}
                        expanded={expanded === `panel${index}`}
                        onChange={handleChange(`panel${index}`)}
                    >
                        <TransparentAccordionSummary
                            expandIcon={<ChevronDown />}
                            aria-controls={`panel${index}bh-content`}
                            id={`panel${index}bh-header`}

                        >
                            <div className="flex flex-col w-full">
                                <Typography variant="h6" >
                                    {team.Name}
                                </Typography>
                                <Typography variant="caption">
                                    {team.Postion}
                                </Typography>

                            </div>
                        </TransparentAccordionSummary>
                        <TransparentAccordionDetails>
                            <div className="lg:flex">
                                {/* <div className="lg:w-2/12">
                                    <div className="lg:float-left lg:mr-5 mb-5">
                                        <img
                                            src={team.image}
                                            alt={`${team.companyName}`}
                                            title={`${team.companyName}`}
                                            className="rounded-xl shadow shadow-blue-900/75 mx-auto"
                                        />
                                    </div>
                                </div> */}
                                <div>
                                    <div className="lg:float-right">
                                        <div className="darkMode">
                                            {team.bio}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </TransparentAccordionDetails>
                    </TransparentAccordion>
                ))}
            </div>
        </div>
    )
}

export default ManagementTeam